import React, {useState, useEffect, useMemo} from 'react';
import {useSelector, useDispatch} from "react-redux";
import Tour from 'reactour'
import Button from "@mui/material/Button";
import {ANALAGOUSCOLOR1, PRIMARYCOLOR} from "../helpers/ThemeSettings";
import Typography from "@mui/material/Typography";
import { updateTour } from "../../redux/uiSlice";
import {Flex} from "reflexbox";
import { useTheme } from '@mui/material/styles';

const ReactTourStepper = () => {
  const theme = useTheme();
  const [isTourOpen, setIsTourOpen] = useState(false);
  const initialTourState = useSelector((state) => state.ui?.tour);
  useEffect(()=> {
    setIsTourOpen(initialTourState)
  },[initialTourState]);

  const dispatch = useDispatch();

  const steps = useMemo(() => {
    const popperStyle = {
      borderRadius: 10,
      padding: '34px 24px 24px 24px',
      maxWidth: '260px',
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.text.primary,
      boxShadow: theme.shadows[8],
    };
    const pillStyle = {
      color: theme.palette.primary.contrastText,
      borderRadius: '20px',
      padding: '4px 8px',
      marginRight: '6px',
      paddingLeft: '10px',
      paddingRight: '10px',
      minWidth: '76px',
      textAlign: 'center',
      justifyContent: 'center',
    };
    const pausedBg = theme.palette.grey[600];
    const pausedPillStyle = { ...pillStyle, color: theme.palette.getContrastText(pausedBg) };

    return [
      {
        selector: "#tour2",
        content: <Typography>Your current score.  <br/>  <br/>Earn up to 100 points per question.</Typography>,
        style: popperStyle,
      },
      {
        selector: "#tour3",
        content:
        <Flex style={{flexDirection: 'column'}}>
          <Typography>If two teams have equal points, time spent on questions is used as a tie-breaker </Typography>
          <Typography style={{fontWeight: 'bold', marginTop: '8px'}}>Note the timer color:</Typography>
          <Flex id={'pills with labels'} style={{marginTop: '8px'}}>
            <Flex style={{backgroundColor: PRIMARYCOLOR, ...pillStyle}}>
              <Typography> Running </Typography>
              </Flex>
            <Flex style={{ backgroundColor: pausedBg, ...pausedPillStyle }}>
              <Typography> Paused</Typography>
            </Flex>
          </Flex>
          <br/>
          <Typography>The game timer ONLY runs on question screens. Take your time and soak up the sights between questions.</Typography>
        </Flex>,
        style: popperStyle,
      },
    ];
  }, [theme]);

  //https://www.npmjs.com/package/reactour/v/1.18.7

  return (<>
    <Tour
      steps={steps}
      isOpen={isTourOpen}
      showBadge={false}
      showCloseButton={true}
      onRequestClose={() => {
        setIsTourOpen(false);
        dispatch(updateTour(false));
      }}
      maskSpace={5}
      rounded={2}
      disableInteraction={true}
      showNumber={false}
      showNavigation={false}
      accentColor={PRIMARYCOLOR}
      prevButton={<Button component="div" >Back</Button>}
      nextButton={<Button component="div" variant="contained" sx={{ bgcolor: ANALAGOUSCOLOR1, color: theme.palette.getContrastText(ANALAGOUSCOLOR1) }}>Next</Button>}
      lastStepNextButton={<Button component="div" variant="contained" sx={{ bgcolor: ANALAGOUSCOLOR1, color: theme.palette.getContrastText(ANALAGOUSCOLOR1) }}>Done</Button>}

    />
    </>)
};

export default ReactTourStepper
